import type { FC } from "react";
import type { FallbackProps } from "react-error-boundary";
import { ActionButton, ActionButtonIntent, SymbolIcon, VStack } from "widgets";

export const FallbackPanel: FC<FallbackProps> = ({ resetErrorBoundary, error }) => {
  return (
    <div role="alert" style={{ textAlign: "center" }}>
      <VStack spacing={20} style={{ alignItems: "center", marginTop: 20 }}>
        <VStack style={{ alignItems: "center" }}>
          <SymbolIcon
            icon="error"
            size={80}
            style={{ color: "#B5183F", fontVariationSettings: '"FILL" 0, "wght" 200, "GRAD" 0, "opsz" 48' }}
          />
          <div style={{ textAlign: "left", fontSize: 40, fontWeight: 350, lineHeight: 0.75 }}>
            Something
            <br />
            went <span style={{ color: "#B5183F", textShadow: "0 0 8px #B5183F55" }}>wrong</span>
          </div>
        </VStack>
        <pre style={{ color: "#B5183F", maxWidth: "calc(100% - 10px)", margin: "0 5px" }}>
          {(error as Error).message}
        </pre>
        <ActionButton
          onPress={() => {
            resetErrorBoundary();
          }}
          label="Reset"
          icon="restart_alt"
          intent={ActionButtonIntent.Danger}
        />
      </VStack>
    </div>
  );
};
